import PropTypes from 'prop-types';
import React from 'react';
import { useAsyncFn } from 'react-use';

import { __t } from '@mssgme/shared';
import { useModalThemes } from '../../../hooks';
import { ThemedButton, useStep } from '../../../UI';

import styles from './StepsFooter.scss';

StepsFooter.propTypes = {
    next: PropTypes.oneOfType([PropTypes.bool, PropTypes.func]),
    prev: PropTypes.oneOfType([PropTypes.bool, PropTypes.func]),
    disabled: PropTypes.bool,
};

export function StepsFooter({ prev, next, disabled }) {
    const { contentStyle } = useModalThemes();
    const { gotoPreviousStep, gotoNextStep } = useStep();

    const [{ loading: isFetchingPrev }, handlePrev] = useAsyncFn(async () => {
        if (typeof prev === 'function') {
            return prev();
        }

        gotoPreviousStep();
    }, [prev, gotoPreviousStep]);

    const [{ loading: isFetchingNext }, handleNext] = useAsyncFn(async () => {
        if (typeof next === 'function') {
            return next();
        }

        gotoNextStep();
    }, [next, gotoNextStep]);

    return (
        <footer className={styles.root}>
            {prev && (
                <ThemedButton
                    className={styles.button}
                    theme={contentStyle}
                    fullWidth={!next}
                    contour
                    type="submit"
                    disabled={disabled}
                    isFetching={isFetchingPrev}
                    onClick={handlePrev}
                >
                    {__t('previous')}
                </ThemedButton>
            )}

            {next && (
                <ThemedButton
                    className={styles.button}
                    theme={contentStyle}
                    fullWidth={!prev}
                    type="submit"
                    disabled={disabled}
                    isFetching={isFetchingNext}
                    onClick={handleNext}
                >
                    {__t('next')}
                </ThemedButton>
            )}
        </footer>
    );
}
